import { createHashHistory } from 'history';
export const history = createHashHistory({
  basename: '',
  hashType: 'slash',
});



// WEBPACK FOOTER //
// ./src/routes/history.js